import { makeApiRequest } from 'actions/api';
import { GET_MEAL_BADGES_V3 } from 'lib/constants/v3Actions';
import RequestService from 'services/RequestService';

export const getMealBadges = menuSlug =>
  makeApiRequest({
    requestType: GET_MEAL_BADGES_V3,
    method: RequestService.v3.getMealBadges,
    params: { menuSlug },
  });
